var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vtrend-licheng",class:[_vm.nClass]},[_c('div',{attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }